import type { NextRouter } from 'next/router';
import type { match } from 'react-router';
import {
  MEMBERS_OVERVIEW_NEXTJS_SUBPATH,
  OVERVIEW_SUBPATH,
} from '@peloton/links/members';
import { ME } from '@engage/members/models';
import { toProfileUrlTemplate } from './profile';

export type MatchPath = match<{ userId: string }>;

export const OVERVIEW_ROUTE = toProfileUrlTemplate(OVERVIEW_SUBPATH);

export const MEMBERS_OVERVIEW_ROUTE = toProfileUrlTemplate(
  MEMBERS_OVERVIEW_NEXTJS_SUBPATH,
);

export const matchOverviewPath = (path: string): boolean =>
  path === MEMBERS_OVERVIEW_ROUTE;

export const getViewedMemberUsernameOrIdFromPath = (path: NextRouter) => {
  const pathWithId = matchOverviewPath(path.pathname);
  return pathWithId ? decodeURIComponent(path.query.memberId as string) : ME;
};
